export default {
  hasCommunity(state) {
    return Boolean(
      state.community && state.community.available && state.community.deep_link
    );
  }
};
